import loadable from '@loadable/component';

const PriceFilter = loadable(
  () =>
    import(
      /* webpackChunkName: "PriceFilter.loadable" */ 'app/shared/modules/MobileSRP/Header/FilterModules/PriceFilter/component'
    ),
);

export default PriceFilter;
